import Image from "next/legacy/image";
import Link from "next/link";
import { blurDataURL } from "../../../utils/constants/images";
import { NEWS_LIST_URL } from "../../../utils/constants/websiteUrls";
import Badge from "../../common/Badge";
import ClockIcon from "../../common/icons/ClockIcon";
import RedDividerH from "../../common/RedDividerH";

const NewsCard = ({ article }) => {
  return <>
    <Link href={`${NEWS_LIST_URL}/${article.slug}`}>

      {" "}
      <div className="group relative transform transition duration-500 hover:scale-105">
        <div className="relative w-full h-80 bg-white rounded-md overflow-hidden group-hover:opacity-75 sm:aspect-w-2 sm:aspect-h-1 sm:h-64 lg:aspect-w-1 lg:aspect-h-1">
          <Image
            src={article?.thumbnail}
            alt="News Thumbnail"
            objectFit="cover"
            layout="fill"
            quality={100}
            placeholder="blur"
            blurDataURL={blurDataURL}
            className="absolute w-full h-full object-center object-cover"
          />

          <div
            aria-hidden="true"
            className="bg-gradient-to-b from-transparent to-black opacity-100 absolute inset-0"
          ></div>
          <div className="p-6 flex items-end absolute inset-0">
            {article.category && (
              <Badge categoryName={article.category.name} />
            )}
            <div>
              <RedDividerH />

              <h1 className="mt-2 mb-4 font-semibold text-white text-base lg:text-xl xl:text-xl 2xl:text-xl">
                <span className="absolute inset-0"></span>
                {article?.title}
              </h1>

              <span className="absolute bottom-3 left-[24px] text-center text-xs font-normal text-gray-400 break-words inline-flex justify-center items-center">
                <ClockIcon />
                {article?.time_ago}
                <span
                  className="h-3 w-0.5 bg-gray-400 mr-2 ml-2"
                  aria-hidden="true"
                ></span>
                <span className="text-gray-400">
                  {" "}
                  {article?.group === "UNDER20" ||
                  article?.group === "UNDER17"
                    ? "ACADEMY"
                    : article?.group}
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>

    </Link>
  </>;
};

export default NewsCard;
